





























































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { apiSupplierDetail, apiSupplierAdd, apiSupplierEdit } from '@/api/material'
import MaterialSelect from '@/components/material-select/index.vue'
import AreaSelect from '@/components/area-select.vue'

@Component({
  components: {
    MaterialSelect,
    AreaSelect
  }
})
export default class SupplierEdit extends Vue {
    activeTab = 'basic'
    loading = false
    submitting = false
    isEdit = false

    // 营业执照图片列表
    licenseImageList: string[] = []

    formData: any = {
      id: '',
      supplier_no: '',
      supplier_name: '',
      supplier_type: '1',
      contact_person: '',
      contact_phone: '',
      contact_email: '',
      province: '',
      city: '',
      district: '',
      address: '',
      business_license: '',
      license_image: '',
      tax_number: '',
      bank_name: '',
      bank_account: '',
      bank_account_name: '',
      payment_terms: '',
      payment_cycle: '1',
      payment_days: 30,
      min_order_amount: 0,
      delivery_days: 3,
      quality_rating: 5.0,
      delivery_rating: 5.0,
      service_rating: 5.0,
      cooperation_status: '1',
      remark: '',
      total_transactions: 0,
      total_purchase_amount: 0.00,
      current_balance: 0.00,
      last_purchase_time: 0,
      last_payment_time: 0
    }

    rules: any = {
      supplier_no: [
        { required: true, message: '请输入供应商编号', trigger: 'blur' }
      ],
      supplier_name: [
        { required: true, message: '请输入供应商名称', trigger: 'blur' }
      ],
      supplier_type: [
        { required: true, message: '请选择供应商类型', trigger: 'change' }
      ],
      contact_person: [
        { required: true, message: '请输入联系人', trigger: 'blur' }
      ],
      contact_phone: [
        { required: true, message: '请输入联系电话', trigger: 'blur' },
        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
      ]
    }

    created () {
      this.isEdit = this.$route.path.includes('supplier_edit')
      if (this.isEdit) {
        const id = this.$route.query.id
        if (id) {
          this.loadSupplierDetail(id)
        }
      } else {
        this.generateSupplierNo()
      }
    }

    loadSupplierDetail (id: any) {
      this.loading = true
      apiSupplierDetail({ id })
        .then((res: any) => {
          if (res) {
            // 转换评分字段为数字类型
            this.formData = {
              ...res,
              quality_rating: parseFloat(res.quality_rating) || 5.0,
              delivery_rating: parseFloat(res.delivery_rating) || 5.0,
              service_rating: parseFloat(res.service_rating) || 5.0,
              payment_days: parseInt(res.payment_days) || 30,
              delivery_days: parseInt(res.delivery_days) || 3,
              min_order_amount: parseFloat(res.min_order_amount) || 0,
              cooperation_status: res.cooperation_status ? String(res.cooperation_status) : '1',
              supplier_type: res.supplier_type ? String(res.supplier_type) : '1'
            }

            // 设置营业执照图片列表
            if (this.formData.license_image) {
              this.licenseImageList = [this.formData.license_image]
            }
          }
        })
        .finally(() => {
          this.loading = false
        })
    }

    generateSupplierNo () {
      // 生成供应商编号逻辑，这里可以根据实际需求调整
      const timestamp = new Date().getTime().toString()
        .slice(-6)
      const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0')
      this.formData.supplier_no = `SUP${timestamp}${random}`
    }

    handleSubmit () {
      (this.$refs.form as any).validate((valid: boolean) => {
        if (!valid) {
          this.$message.warning('请检查表单填写是否完整')
          return
        }

        this.submitting = true

        // 同步营业执照图片数据
        if (this.licenseImageList && this.licenseImageList.length > 0) {
          this.formData.license_image = this.licenseImageList[0]
        } else {
          this.formData.license_image = ''
        }

        const api = this.isEdit ? apiSupplierEdit : apiSupplierAdd
        const params = { ...this.formData }

        // 处理评分数据，确保是数字
        params.quality_rating = Number(params.quality_rating) || 5.0
        params.delivery_rating = Number(params.delivery_rating) || 5.0
        params.service_rating = Number(params.service_rating) || 5.0
        params.payment_days = Number(params.payment_days) || 30
        params.delivery_days = Number(params.delivery_days) || 3
        params.min_order_amount = Number(params.min_order_amount) || 0
        params.cooperation_status = Number(params.cooperation_status) || 1

        api(params)
          .then((res: any) => {
            this.goBack()
          })
          .finally(() => {
            this.submitting = false
          })
      })
    }

    goBack () {
      this.$router.go(-1)
    }
}
